import { useRegistration } from "@/context/RegistrationContext";
import { ArrowLeft, ArrowRight, ScrollText } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

export default function UndertakingStep({ onNext, onBack }) {
  const { state, update } = useRegistration();
  const confirmed = state.undertaking?.confirmed;
  const name = state.candidate.name || "[Candidate Name]";

  const toggle = (v) =>
    update({
      undertaking: {
        confirmed: !!v,
        signedAt: v ? new Date().toISOString() : null,
      },
    });

  return (
    <div className="space-y-6">
      <div className="mu-card p-6 md:p-10">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-[#FBE7EA] flex items-center justify-center">
            <ScrollText className="h-5 w-5 text-[#B60F2A]" />
          </div>
          <div>
            <div className="tiny-label">Legal Undertaking</div>
            <h2 className="text-xl font-semibold text-[#111]">
              Declaration by Candidate
            </h2>
          </div>
        </div>

        <div className="mt-6 border border-[#E5E7EB] rounded-2xl p-5 md:p-7 bg-[#F7F7F7] text-[#111] leading-relaxed text-sm space-y-4">
          <p>
            I, <span className="font-semibold">{name}</span>, hereby declare
            that the information provided by me in this registration form is
            true, complete and correct to the best of my knowledge and belief.
            I understand that any misrepresentation, suppression of material
            fact, or submission of false documents will render my admission
            liable to be cancelled at any stage.
          </p>
          <p>
            I have read and understood the University&rsquo;s rules, regulations and
            code of conduct including — but not limited to — the UGC
            regulations on curbing the menace of ragging in higher educational
            institutions. I undertake to abide by these regulations during my
            course of study at Mahindra University.
          </p>
          <p>
            I authorise the University to use my mobile number and email
            address for all official communications until the completion of my
            program.
          </p>
        </div>

        <label
          className="mt-6 flex items-start gap-3 p-4 rounded-xl border border-[#E5E7EB] cursor-pointer hover:border-[#B60F2A] transition"
          data-testid="undertaking-confirm-wrap"
        >
          <Checkbox
            checked={confirmed}
            onCheckedChange={toggle}
            data-testid="undertaking-checkbox"
            className="mt-0.5 data-[state=checked]:bg-[#B60F2A] data-[state=checked]:border-[#B60F2A]"
          />
          <div>
            <div className="text-sm font-medium text-[#111]">I Confirm</div>
            <div className="text-xs text-[#6B7280] mt-0.5">
              I have read, understood and agree to the declaration above.
            </div>
          </div>
        </label>
      </div>

      <div className="flex justify-between">
        <button onClick={onBack} className="mu-btn-secondary" data-testid="btn-back-undertaking">
          <ArrowLeft className="h-4 w-4" /> Back
        </button>
        <button
          onClick={() => {
            if (!confirmed) {
              toast.error("Please confirm the undertaking to continue");
              return;
            }
            onNext();
          }}
          className="mu-btn-primary"
          data-testid="btn-next-undertaking"
          disabled={!confirmed}
        >
          Continue <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
